import { DiffType } from '@ardoq/data-model';
import { NavigatorViewInterface } from './NavigatorViewInterface';
import { DiffMode } from '@ardoq/api-types';
import {
  enhancedScopeDataOperations,
  scopeDataOperations,
} from '@ardoq/scope-data';

export const getNavigatorStubViewInterface = (): NavigatorViewInterface => ({
  isComponentInFlexibleModel: () => false,
  isFlexibleWorkspace: () => false,
  canComponentHaveChildren: () => false,
  getComponentLock: () => false,
  getComponentTypeId: () => null,
  getCSSFilterColor: () => null,
  getComponentRepresentationData: () => null,
  getSortedComponentChildrenIds: () => [],
  isIncludedInContextByFilter: () => false,
  hasComponentWriteAccess: () => false,
  isScenarioContextComponent: () => false,
  getVisualDiffType: () => DiffType.NONE,
  isWorkspaceEmpty: () => true,
  getWorkspaceRootComponents: () => [],
  isWorkspace: () => false,
  hasWorkspaceWriteAccess: () => false,
  getRootWorkspaceIdOfComponent: () => null,
  getComponentName: () => '',
  getComponentOrder: () => -1,
  getWorkspaceName: () => '',
  getScenarioName: () => '',
  getComponentCssClassNames: () => null,
  getComponentDisplayColorAsSVGAttributes: () => ({ fill: '', stroke: '' }),
  isComponentExternallyManaged: () => false,
  isComponentExternallyMissing: () => false,
  currentUserIsOrgAdmin: () => false,
  isWorkspaceExternallyManaged: () => false,
  getLinkedSourceComponents: () => [],
  getLinkedTargetComponents: () => [],
  hasFeature: () => false,
  isComponent: () => false,
  get: () => null,
  getComponentsData: async () => ({}),
  copyComponents: async () => ({ changedComponents: {}, changedModels: {} }),
  isInScenarioMode: () => false,
  getActiveScenarioId: () => null,
  isInDiffMode: () => false,
  getDiffMode: () => DiffMode.MAIN,
  getIsStrictSelection: () => false,
  getScopeDataForComponentIds: () => scopeDataOperations.getEmpty(),
  getDescendants: () => [],
  getTypeOptionsOfWorkspace: (
    _workspaceId: string,
    _parentComponentId: string
  ) => ({ typeOptions: [], componentTypes: [] }),
  getComponentRepresentationDataWithColorShades:
    enhancedScopeDataOperations.getComponentRepresentationDataWithColorShadesFallback,
});
